import { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import sunpin from "../../../asset/sunpin.png";
import { useSelector } from "react-redux";
import { getImageDetails } from "../../../feature/image-slice";
import styleSheet from "./style.module.scss";


// Helper component to programmatically move the map
const MapFlyTo = ({ lat, lng }: { lat: number; lng: number }) => {
  const map = useMap();
  useEffect(() => {
    map.flyTo([lat, lng], 10); // Adjust zoom level as needed
  }, [lat, lng, map]);
  return null;
};

const OrbMap = (prop: any) => {
  const { locations } = prop;
  const imageDetail = useSelector(getImageDetails);
  const [markers, setMarkers] = useState<
    {
      id: any;
      lat: number;
      lng: number;
      label: string;
      pro_id: any;
      orb_id: any;
    }[]
  >([]);

  // Fetch coordinates from OpenStreetMap
  const fetchCoordinates = async (location: any) => {
    const response = await fetch(
      // `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(location.address)}`
      `https://nominatim.openstreetmap.org/search?format=json&q=${location.address}`
    );
    const data = await response.json();
    if (data.length === 0) throw new Error("Location not found");
    return {
      lat: parseFloat(data[0].lat),
      lng: parseFloat(data[0].lon),
      label: location.address,
      id: location.id,
      pro_id: location.pro_id,
      orb_id: location.orb_id,
    };
  };

  const { mutate } = useMutation({
    mutationFn: fetchCoordinates,
    onSuccess: (data) => {
      setMarkers((prev) => {
        const filterPreviousData = prev.filter(
          (data: any) => data.orb_id === locations[0].orb_id
        );
        console.log(data, filterPreviousData);
        return [...filterPreviousData, data];
      });
    },
    onError: (error) => {
      console.error("Geocoding failed:", error);
    },
  });

  // Get custom pin icon if available
  const getCustomIcon = (id: any) => {
    const imgPin = imageDetail?.pin.find((data: any) => data.id == id);
    return new L.Icon({
      iconUrl: imgPin?.img || sunpin,
      iconSize: [20, 32],
      iconAnchor: [16, 32],
      popupAnchor: [0, -32],
    });
  };

  // Geocode all locations on mount
  useEffect(() => {

    if (locations.length) {
      if (locations[0]?.orb_id !== markers[0]?.orb_id) {
        locations?.forEach((location: any) => {
          mutate(location);
        });
      }
    } else {
      setMarkers([]);
    }
  }, [locations, mutate]);

  // Find hovered location for zoom
  const hoveredLocation = locations?.find((loc: any) => loc.hover);
  const hoveredMarker =
    hoveredLocation &&
    markers?.find((m) => m.pro_id === hoveredLocation.pro_id);

  return (
    <div className="position-relative">
      <MapContainer
        center={[20, 0]}
        zoom={2}
        scrollWheelZoom={true}
        // style={{ height: "450px", width: "100%", borderRadius: "8px" }}
         className={`${styleSheet.orb_map_container}`}
      >
        <TileLayer
          attribution='&copy; <a href="https://carto.com/">CARTO</a>'
          url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
        />

        {markers.map((marker, idx) => (
          <Marker
            key={idx}
            position={[marker.lat, marker.lng]}
            icon={getCustomIcon(marker.id)}
          >
            <Popup>{marker.label}</Popup>
          </Marker>
        ))}

        {hoveredMarker && (
          <MapFlyTo lat={hoveredMarker.lat} lng={hoveredMarker.lng} />
        )}
      </MapContainer>
    </div>
  );
};

export default OrbMap;
